import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { AppBackButtonComponent } from './app-back-button.component';

@NgModule({
  declarations: [AppBackButtonComponent],
  imports: [CommonModule, MaterialModule],
  exports: [AppBackButtonComponent],
})
export class AppBackButtonModule {}
